import script from "./SectionTemplateTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTemplateTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTemplateTableRow.vue?vue&type=style&index=0&id=459b4ffc&lang=css"

const __exports__ = script;

export default __exports__